import TooltipTag from "../../components/UI/TooltipTag";
import {
  textColor,
  pillColor,
  tooltipTitle,
  iconTypeMap,
} from "./DosingMapping";

export const getCellRenderer = (text: string | null, type: string) => {
  if (text === null) return "-";
  if (
    text === "Data Pending" ||
    text === "Data Missing" ||
    text === "Data Discrepancy"
  ) {
    return (
      <TooltipTag
        tooltipTitle={tooltipTitle[text]}
        tagColor={pillColor[text]}
        textColor={textColor[text]}
      >
        {text}
      </TooltipTag>
    );
  }
  if (type === "float") {
    if (!isNaN(Number(text))) {
      return <span>{Number(text).toFixed(2)}</span>;
    }
  }
  if (pillColor[text]) {
    return (
      <TooltipTag
        tooltipTitle={tooltipTitle[text]}
        tagColor={pillColor[text]}
        textColor={textColor[text]}
        icon={iconTypeMap[text]}
        tagStyle={{ borderRadius: "4px" }}
      >
        {text}
      </TooltipTag>
    );
  }
  return text;
};
